import { useTenantSetting } from "@nestoca/multi-tenant";
import { OptionItem } from "@shared/ui";
import { useTranslation } from "react-i18next";

import { PROPERTY_PURPOSE } from "./property-purpose.const";

const PROPERTY_PURPOSE_LABEL: Record<string, string> = {
  OWNER_OCCUPIED: "owned-property:ownerOccupied",
  OWNER_OCCUPIED_AND_RENTAL: "owned-property:ownerOccupiedWithRental",
  RENTAL: "owned-property:rental",
  SECONDARY_RESIDENCE: "owned-property:secondaryResidence",
  SeasonalHome: "owned-property:seasonalHome",
  VACANT: "owned-property:vacant",
  COTTAGE_PROPERTY: "owned-property:cottageProperty",
  RESERVE_PROPERTY: "owned-property:reserveProperty",
  OTHER: "owned-property:other",
};

export const useOwnedPropertyCurrentPurposeOptions = (): OptionItem[] => {
  const { settings: { ownedPropertyPurposeTypes } = {} } =
    useTenantSetting("typesOverride");

  const { t } = useTranslation("owned-property");

  if (!ownedPropertyPurposeTypes) {
    return PROPERTY_PURPOSE.map((option) => ({
      value: option.value,
      label: t(option.label),
    }));
  }

  return ownedPropertyPurposeTypes
    .filter((type) => type !== "SOLD")
    .map((type) => ({
      value: type,
      label: t(PROPERTY_PURPOSE_LABEL[type] ?? type),
    }));
};
